<template lang="pug">
  ul.side-nav
    li.side-nav__item(
      v-for="link in sideNavData.links"
    )
      router-link.side-nav__link(
      v-bind:to="link.path"
      :active-class="'side-nav__link_active'"
      ) {{link.text}}
</template>
<script>
export default {
  name: "SideNav",
  components: {},
  props: ["sideNavData"],
  methods: {
    isActive(link) {
      if (link.path === this.sideNavData.links[0].path) {
        if (link.path === this.$route.path) {
          return true;
        } else if (
          link.second_path &&
          this.$route.path.indexOf(link.second_path) > -1
        ) {
          return true;
        }
        return false;
      }
      return this.$route.path.indexOf(link.path) > -1;
    }
  }
};
</script>
